/*
 * @Author: changcheng
 * @LastEditTime: 2023-06-12 14:43:43
 */
import React, { FC, useEffect, useState } from "react";
import { Table, Space, Button, message, Select, Form, Modal } from "antd";
import axios from "@/axios/axios";
import { InvoinceModal } from "./invoiceModal";
import { store } from "@/store/index";
let tradeNo = "";
function getUrlParams2(url: String) {
  let urlStr = url.split("?")[1];
  const urlSearchParams = new URLSearchParams(urlStr);
  const result = Object.fromEntries(urlSearchParams.entries());
  return result;
}
// 下载文件
function downloadFileForExcel(res: any, name: any) {
  let blob1 = new Blob([res], {
    type: "application/json",
  });
  console.log(blob1.text());
  blob1
    .text()
    .then(function (value) {
      console.log(value);
      var obj = JSON.parse(value);
      console.log(obj.code);
      console.log(obj.msg);
      if (obj.code !== 0) {
        alert(obj.msg);
      }
    })
    .catch(function (err) {
      let blob = new Blob([res], {
        type: "application/vnd.ms-excel",
      }); // 转化为blob对象
      let filename = name + ".xlsx";

      const blobURL = window.URL.createObjectURL(blob); // 将blob对象转为一个URL
      const tempLink = document.createElement("a"); // 创建一个a标签
      tempLink.style.display = "none";
      tempLink.href = blobURL;
      tempLink.setAttribute("download", filename); // 给a标签添加下载属性
      if (typeof tempLink.download === "undefined") {
        tempLink.setAttribute("target", "_blank");
      }
      document.body.appendChild(tempLink); // 将a标签添加到body当中
      tempLink.click(); // 启动下载
      document.body.removeChild(tempLink); // 下载完毕删除a标签
      window.URL.revokeObjectURL(blobURL);
    });
}
export const OrderRecord: FC<any> = () => {
  const {
    storeData: { userInfo },
  } = store.getState();
  const { chargeMode } = userInfo;
  const payModalColumns = [
    {
      title: "订单编号",
      dataIndex: "tradeNo",
      key: "tradeNo",
    },
    {
      title: "商品名称",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "课时数量",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "总价",
      dataIndex: "payAmountText",
      key: "payAmountText",
    },
    {
      title: "下单时间",
      dataIndex: "orderFinishTimeText",
      key: "orderFinishTimeText",
    },
    {
      title: "订单状态",
      dataIndex: "tradeStatusDesc",
      key: "tradeStatusDesc",
    },
    {
      title: "操作",
      key: "action",
      render: (text: any, record: any) => (
        <Space
          size="middle"
          style={{
            width: "180px",
          }}
        >
          <Button
            onClick={() => {
              setOrderInfo(record);
              setShowInvoinceModal(true);
            }}
            type="link"
            disabled={record.receiptApplyStatus === 1}
          >
            申请发票
          </Button>
        </Space>
      ),
    },
  ];
  const creditCardModalColumns = [
    {
      title: "订单编号",
      dataIndex: "tradeNo",
      key: "tradeNo",
    },
    {
      title: "商品名称",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "数量",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "总价",
      dataIndex: "payAmountText",
      key: "payAmountText",
    },
    {
      title: "下单时间",
      dataIndex: "orderFinishTimeText",
      key: "orderFinishTimeText",
    },
    {
      title: "订单状态",
      dataIndex: "tradeStatusDesc",
      key: "tradeStatusDesc",
    },
    {
      title: "操作",
      key: "action",
      render: (text: any, record: any) => (
        <Space
          size="middle"
          style={{
            width: "180px",
          }}
        >
          <Button
            onClick={() => {
              tradeNo = record.tradeNo;
              setOrderInfo(record);
              setShowCardPassWordModal(true);
              getCardPassWordList();
            }}
            type="link"
          >
            查看卡密
          </Button>
          <Button
            onClick={() => {
              setOrderInfo(record);
              setShowInvoinceModal(true);
            }}
            type="link"
            disabled={record.receiptApplyStatus === 1}
          >
            申请发票
          </Button>
        </Space>
      ),
    },
  ];
  const [columns] = useState(
    chargeMode === 2 ? payModalColumns : creditCardModalColumns
  );
  let isAliPay = window.location.href.includes("currentPayTradeNo");
  const onChange = (pageNumber: any) => {
    let newPage = { ...page, currentPage: pageNumber };
    setPage(newPage);
    setCount(count + 1);
  };
  const onCardChange = (pageNumber: any) => {
    let newPage = { ...page, currentPage: pageNumber };
    setCardPassWordPage(newPage);
    setCount(count + 1);
  };
  const [showInvoinceModal, setShowInvoinceModal] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 10,
    totalResultSize: 0,
  });
  const [cardPassWordPage, setCardPassWordPage] = useState({
    currentPage: 1,
    pageSize: 10,
    totalResultSize: 0,
  });
  const [showCardPassWordModal, setShowCardPassWordModal] = useState(false);
  const [cardPassWordlist, setCardPassWordList] = useState([]);
  const [orderInfo, setOrderInfo] = useState({});
  useEffect(() => {
    getList();
    tradeNo && getCardPassWordList();
  }, [count]);
  // 纪录列表
  const [list, setList] = useState([]);
  const getList = async () => {
    const body = {
      page: {
        currentPage: page.currentPage,
        pageSize: page.pageSize,
      },
      currentPayTradeNo: isAliPay
        ? getUrlParams2(window.location.href).currentPayTradeNo
        : "",
    };
    const {
      code,
      data: {
        itemOrderList,
        page: { currentPage, totalResultSize },
      },
      msg,
    }: any = await axios.post(`/shop/front/ce/order/list`, body);
    if (code === 0) {
      setList(itemOrderList || []);
      setPage({
        ...page,
        currentPage,
        totalResultSize,
      });
    } else {
      message.error(msg);
    }
  };
  /**
   * 查看卡密
   */
  const getCardPassWordList = async () => {
    const body = {
      page: {
        currentPage: cardPassWordPage.currentPage,
        pageSize: cardPassWordPage.pageSize,
      },
      tradeNo,
    };
    const {
      code,
      data: {
        itemCardList,
        page: { currentPage, totalResultSize },
      },
      msg,
    }: any = await axios.post(`/shop/front/ce/order/card/list`, body);
    if (code === 0) {
      setCardPassWordList(itemCardList || []);
      setPage({
        ...page,
        currentPage,
        totalResultSize,
      });
    } else {
      message.error(msg);
    }
  };
  /**
   * 导出卡密列表
   */
  const cardExport = async () => {
    await axios({
      url: `/shop/front/ce/order/${tradeNo}/card/export`,
      method: "post",
      responseType: "blob",
      data: {
        //"operateMobile": "",
        //"mobile": "",
        //"cardNo" : "",
      },
    })
      .then((res: any) => {
        downloadFileForExcel(res, "订单记录");
      })
      .catch((e: any) => {
        message.error("导出异常");
      });
  };
  const cardPassWordColumns = [
    {
      title: "卡号",
      dataIndex: "cardNo",
      key: "cardNo",
    },
    {
      title: "密码",
      dataIndex: "cardPassword",
      key: "cardPassword",
    },
  ];
  return (
    <div>
      <h2>订单记录</h2>
      <Table
        bordered={true}
        dataSource={list}
        columns={columns}
        pagination={{ onChange: () => onChange }}
      />
      <Modal
        open={showCardPassWordModal}
        title="卡密列表"
        onOk={() => {
          setShowCardPassWordModal(false);
        }}
        onCancel={() => {
          setShowCardPassWordModal(false);
        }}
      >
        <p
          style={{
            textAlign: "right",
          }}
        >
          <Button type="primary" onClick={cardExport}>
            导出列表
          </Button>
        </p>
        <Table
          bordered={true}
          dataSource={cardPassWordlist}
          columns={cardPassWordColumns}
          pagination={{ onChange: () => onCardChange }}
        ></Table>
      </Modal>
      <InvoinceModal
        showInvoinceModal={showInvoinceModal}
        setShowInvoinceModal={setShowInvoinceModal}
        orderInfo={orderInfo}
        getList={getList}
      />
    </div>
  );
};
